import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

interface IPutImageUseResponse {
  isUsed: boolean;
  usedCount: number;
}

async function putImageUse(imageId: number): Promise<AxiosResponse<FetchResult<IPutImageUseResponse>>> {
  const response = await instance.put(`/images/used-image/${imageId}`);
  return response;
}

const usePutImageUse = (onError?: (err: AxiosError) => void) => {
  const { mutateAsync } = useMutation({
    mutationKey: ['put', `/images/used-image/:imageId`],
    mutationFn: (imageId: number) => putImageUse(imageId),
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync };
};

export default usePutImageUse;
